export const nullToEmptyString = (obj) => {
    Object.entries(obj).forEach(([key, value]) => {
        obj[key] = value === null ? "" : value
    })
}

export const emptyStringToNull = (obj) => {
    Object.entries(obj).forEach(([key, value]) => {
        obj[key] = value === "" ? null : value
    })
}